<loading-text-display [isLoading]="isPageLoading">
    <div class="container-fluid fall-management-page fall-confirm-page" [ngClass]="['step-' + currentStep, 'brand-' + appBrand, (confirmId === null || confirmDataValid === false) ? 'is-expired' : '']">
        <span class="fall-state-icon" aria-hidden="true"></span>
        <span class="fall-verify-badge" aria-hidden="true">&#10003;</span>
        <div class="row">
            <div class="col-sm">
                <picture *ngIf="appBrand === 'TeleHear'; else brandLogo">
                    <img class="fall-management-logo" src="./assets/TeleHear.svg" alt="TeleHear" />
                </picture>

                <ng-template #brandLogo>
                    <img class="fall-management-logo" [src]="'./assets/' + appBrand + '-web.png'" [alt]="appBrand">
                </ng-template>
            </div>
        </div>
        <div class="row" *ngIf="confirmId !== null && confirmDataValid">
            <div class="col-sm">
                <wizard #confirmContactWizard [showDefaultControls]="false" (currentStepIndexChange)="onCurrentStepChange($event)">
                    <wizard-step [nextAction]="verifyPhoneNumber()" class="fall-management-text-center">
                        <div class="fall-management-text-center">
                            <h1 class="fall-title">{{_catService.getString("CloudTray_FallManagement_Common_VerifyPhoneTitle")}}</h1>
                            <p class="fall-copy">{{_catService.getString("CloudTray_FallManagement_Common_VerifyPhoneMessage")}}</p>
                            <div class="fall-phone-input-group">
                                <input id="phoneNumber" type="tel" inputmode="tel" autocomplete="tel"
                                    [placeholder]="_catService.getString('CloudTray_FallManagement_Common_PhonePlaceholder')" [(ngModel)]="phoneNumber"
                                    (ngModelChange)="transformPhoneNumber();" class="form-control" />
                                <div class="fall-field-message">
                                    <label *ngIf="invalidPhoneNumber" style="color:red; font-size:12px; ">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_InvalidPhoneNumberError")}}</label>
                                </div>
                            </div>
                        </div>
                    </wizard-step>
                    <wizard-step [nextAction]="confirmParticipation()">
                        <div class="fall-management-text-center">
                            <h1 class="fall-title">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_InviteTitle")}}</h1>
                            <p class="fall-copy">{{_catService.formatString("CloudTray_FallManagement_ContactConfirmation_InviteMessage", patientName || _catService.getString("CloudTray_FallManagement_Common_ContactNameFallback"))}}</p>
                            <p class="fall-copy">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_InviteDetails")}}</p>
                            <p class="fall-copy">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_InviteAction")}}</p>
                        </div>
                    </wizard-step>
                    <wizard-step>
                        <div class="fall-management-text-center">
                            <h1 class="fall-title">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_ConfirmedTitle")}}</h1>
                            <p class="fall-copy">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_ConfirmedMessage")}}</p>
                            <p class="fall-copy">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_ConfirmedTextMessage")}}</p>
                            <p class="fall-copy fall-secondary">{{_catService.getString("CloudTray_FallManagement_Common_OptOutPrefix")}} <a href="{{optOutUrl}}">{{_catService.getString("CloudTray_FallManagement_Common_Here")}}</a>.</p>
                        </div>
                    </wizard-step>
                </wizard>
                <button *ngIf="currentStep < 3" [ngClass]="getWizardButtonClass()"
                    [disabled]="!isProperNumber() || awaitingResponse" class="form-control" style="min-width:200px;width: auto;margin: auto;" (click)="goToNextStep()">
                    {{_catService.getString(currentStep === 1 ? "CloudTray_FallManagement_Common_VerifyPhoneButton" : "CloudTray_FallManagement_ContactConfirmation_AcceptButton")}}
                </button>
            </div>
        </div>

        <div class="row" *ngIf="confirmId === null || confirmDataValid === false">
            <div class="col-sm">
                <div class="fall-management-text-center fall-expired-content">
                    <h1 class="fall-title">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_PageExpiredMessage")}}</h1>
                    <p class="fall-copy fall-expired-guidance">
                        {{_catService.getString("CloudTray_FallManagement_ContactConfirmation_OptOutLink1") + " "}}<a href="{{optOutUrl}}">{{_catService.getString("CloudTray_FallManagement_ContactConfirmation_OptOutLink2")}}</a>.
                    </p>
                </div>
            </div>
        </div>
    </div>
</loading-text-display>
